<script>
import axios from 'axios'
import _ from 'lodash'
import laroute from '../laroute'

export default {

    props: {
        'searchquery': null,
        'tagId': null,
        'tagTitle': null,
        'scoped': null,
        'allTags': {
            type: String,
            default: 'Alle Schlagworte'
        },
    },

    data() {
        return {
            query: '',
            faqs: [],
            tag: {
                name: this.allTags,
                id: 0,
            },
            sort: {},
            language: "",
        }
    },

    mounted() {
        this.search(this.query);
    },

    watch: {
        query: _.debounce(function () {
            this.search(this.query);
        }, 300),
    },

    methods: {
        search(query) {
            axios.get(laroute.route('faq.search.index'), {
                params: {
                    q: query,
                    tagId: this.tag.id
                }
            }).then(data => {
                this.faqs = data.data;

                Vue.nextTick(() => {
                    jQuery('#faqs').collapse({
                        toggle: false
                    })
                });
            });
        },

        useTag(id, name) {
            this.tag.id = id;
            this.tag.name = name;

            this.search(this.query);
        }
    },

}
</script>
